module.exports = __webpack_public_path__ + "static/media/ic_kappaletavara_b.03c94013.svg";


//////////////////
// WEBPACK FOOTER
// ./src/map/images/ic_kappaletavara_b.svg
// module id = 1184
// module chunks = 0